import Glide from '@glidejs/glide';
import { breakpoints } from './breakpoints';

document.addEventListener('DOMContentLoaded', function () {
    // Review slider
    const reviewSliders = document.querySelectorAll('.js-reviewSlider');

    reviewSliders.forEach(reviewSlider => {
        const sliderItems = reviewSlider.querySelector('.js-sliderItems');

        const glideInstance = new Glide(sliderItems, {
            type: 'carousel',
            startAt: 0,
            perView: 5,
            gap: 0,
            bound: true,
            breakpoints: {
                [breakpoints.viewport_12]: { perView: 4 },
                [breakpoints.viewport_11]: { perView: 3 },
                [breakpoints.viewport_9]: { perView: 2 },
                [breakpoints.viewport_5]: { perView: 1 }
            },
            autoplay: 3000,
            keyboard: true
        });

        glideInstance.mount();
    });

    // Overlap slider
    const overlapSliders = document.querySelectorAll('.js-overlapSlider');

    overlapSliders.forEach(overlapSlider => {
        const sliderItems = overlapSlider.querySelector('.js-sliderItems');

        const glideInstance = new Glide(sliderItems, {
            type: 'slider',
            startAt: 0,
            perView: 2.2,
            gap: 0,
            bound: true,
            keyboard: true,
            autoplay: false,
            breakpoints: {
                [breakpoints.viewport_9]: { perView: 2.1 },
                [breakpoints.viewport_5]: { perView: 1.05 }
            },
            // dragThreshold: false,
            // swipeThreshold: false
        });

        glideInstance.mount();
    });

    // Call handleMobileSlider initially to set up the correct state on page load
    handleMobileSlider();

    // Re-call handleMobileSlider on window resize to keep the logic responsive
    window.addEventListener('resize', handleMobileSlider);

});

const mobileInstances = [];

function initializeMobileSlider() {
    const mobileSliders = document.querySelectorAll('.js-mobileSlider');
    
    // Check if there are any mobile sliders
    if (mobileSliders.length === 0) return;

    mobileSliders.forEach(mobileSlider => {
        const sliderItems = mobileSlider.querySelector('.js-sliderItems');
        
        // If the slider hasn't been initialized yet
        if (!mobileSlider.dataset.glideMounted && window.innerWidth < breakpoints.viewport_7) {
            const glideInstance = new Glide(sliderItems, {
                type: 'carousel',
                startAt: 0,
                perView: 1,
                gap: 0,
                bound: true,
                keyboard: true
            });

            glideInstance.mount();
            mobileInstances.push(glideInstance);
            mobileSlider.dataset.glideMounted = 'true'; // Mark as mounted
        }
    });
}

function destroyMobileSlider() {
    // Destroy Glide instances when resizing up (viewport > viewport_7)
    if (window.innerWidth >= breakpoints.viewport_7) {
        mobileInstances.forEach(instance => instance.destroy());
        mobileInstances.length = 0;

        // Clean up the dataset attributes for the sliders
        document.querySelectorAll('.js-mobileSlider').forEach(slider => {
            delete slider.dataset.glideMounted;
        });
    }
}

jQuery(document.body).on('updated_cart_totals', function() {
    handleMobileSlider();
});

export function handleMobileSlider() {
    if (window.innerWidth < breakpoints.viewport_7) {
        initializeMobileSlider();  // Initialize the sliders when the viewport is small
    } else {
        destroyMobileSlider();     // Destroy sliders when the viewport is large
    }
}